import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=49c61e3a&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"
import style0 from "./StockList.vue?vue&type=style&index=0&id=49c61e3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c61e3a",
  null
  
)

export default component.exports